// extracted by mini-css-extract-plugin
export default {"box":"InputBox_box__bHeVi"};